import { jsxs, jsx } from 'react/jsx-runtime';
import classes from './index.module.scss.js';

const LiraAdvContainer = ({ idForAd, withPlaceholder, className, inlineStyleForAd, ...divProps }) => {
    return (jsxs("div", { className: `${classes['lira-container']} ${className ?? ''}`, ...divProps, children: [jsx("div", { className: classes['lira-item'], id: idForAd, style: inlineStyleForAd }), withPlaceholder ? jsx("div", { className: classes['lira-placeholder'] }) : null] }));
};

export { LiraAdvContainer };
//# sourceMappingURL=index.js.map
